import React, {useEffect, useState} from "react"
import {BasePopup} from "components/popup"
import styles from "./LinkDepartmentForm.module.css"
import {BaseButton, BaseInput} from "components"
import {handleError, toastError} from "helpers"
import {FormLabel} from "components/Form"
import {departmentsService} from "services"
import {useAllDepartmentForms} from "hooks"
import {DepartmentForm} from "types/departments"
import TaskLibrarySelect from "components/TaskLibrarySelect"

type Props = {
    item?: DepartmentForm
    departmentId: number
    open: boolean
    onClose: () => void
    onSuccess?: () => void
}

export function LinkDepartmentForm(props: Props) {
    const {item, open, departmentId, onClose, onSuccess} = props
    const [departmentForm, setDepartmentForm] = useState<Partial<DepartmentForm>>(item)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const isEdit = !!item

    const {invalidateDepartmentFormsCache} = useAllDepartmentForms({departmentId})

    useEffect(() => {
        if (item) {
            setDepartmentForm(item)
        } else {
            setDepartmentForm({})
        }
    }, [item])

    const onSubmit = async () => {
        try {
            setIsSubmitting(true)
            const {id, tasks, formId, displayName} = departmentForm
            if (!formId || !displayName) {
                toastError("Please fill in all required fields")
                return
            }
            let payload: Partial<DepartmentForm> = {
                formId,
                displayName,
                taskIds: tasks?.map((task) => task.id)
            }
            if (isEdit) {
                await departmentsService.updateDepartmentForm({id, ...payload})
            } else {
                await departmentsService.createDepartmentForm({
                    ...payload,
                    departmentId,
                    allowTaskLinked: true
                })
            }
            onSuccess?.()
            invalidateDepartmentFormsCache()
        } catch (e) {
            handleError(e)
        } finally {
            setIsSubmitting(false)
        }
    }

    const onChangeData = (key: string, value: any) => {
        setDepartmentForm((prev) => ({...prev, [key]: value}))
    }

    return (
        <BasePopup
            isShow={open}
            onClose={onClose}
            leftIcon={isEdit ? "PENCIL" : "PLUS_CIRCLE"}
            leftIconColor="#fff"
            width="40vw"
            closable
            destroyOnClose>
            <div className={styles.headingTitle}>{isEdit ? "Edit Form" : "Create Form"}</div>
            <div className={styles.field}>
                <FormLabel label="Form ID" isRequired />
                <BaseInput
                    type="text"
                    value={departmentForm?.formId}
                    onChange={(value) => onChangeData("formId", value)}
                />
            </div>
            <div className={styles.field}>
                <FormLabel label="Display Name" isRequired />
                <BaseInput
                    type="text"
                    value={departmentForm?.displayName}
                    onChange={(value) => onChangeData("displayName", value)}
                />
            </div>
            <div className={styles.field}>
                <FormLabel label="Task Library" />
                <TaskLibrarySelect
                    departmentId={departmentId}
                    onChange={(options) => onChangeData("tasks", options)}
                    value={departmentForm?.tasks}
                    isMulti
                />
            </div>
            <div className={styles.doneBtn}>
                <BaseButton title="Submit" onClick={onSubmit} className={styles.saveBtn} loading={isSubmitting} />
            </div>
        </BasePopup>
    )
}
